var __WEBPACK_NAMESPACE_OBJECT__ = (function () {
  if (typeof window.hubspot === 'undefined' || typeof window.hubspot.bender === 'undefined') {
    throw new Error('Could not find hubspot.bender global variable.');
  }
  return window.hubspot.bender;
}());